var _style, _circle, _circle2, _path, _g, _g2, _path2, _g3, _g4, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock1Hands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 252.6 251",
    style: {
      enableBackground: "new 0 0 252.6 251"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#747475;}\n\t.st1{fill:#FFFFFF;stroke:#747475;stroke-miterlimit:10;}\n\t.st2{fill:#F9FBFC;}\n\t.st3{fill:#1F2F6D;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 126.5,
    cy: 124.5,
    r: 118.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 126.5,
    cy: 124.5,
    r: 108.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.8,127.5c-1.6-0.9-2.2-3-1.2-4.7c0.9-1.6,3-2.2,4.7-1.2c1.6,0.9,2.2,3,1.2,4.7 C128.5,127.8,126.4,128.4,124.8,127.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.8,22.9c-0.2,0-0.4,0.2-0.4,0.5l0.4,3.4c0,0.2,0.2,0.4,0.5,0.4c0.2,0,0.4-0.2,0.4-0.5l-0.4-3.4 C116.3,23,116.1,22.8,115.8,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.8,24.9c-0.1-0.2-0.3-0.4-0.5-0.3c-0.2,0-0.4,0.3-0.3,0.5l0.7,3.4c0.1,0.2,0.3,0.4,0.5,0.3 s0.4-0.3,0.3-0.5L105.8,24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.5,27.6c-0.1-0.2-0.3-0.3-0.5-0.3s-0.3,0.3-0.3,0.5l1.1,3.2c0.1,0.2,0.3,0.3,0.5,0.3s0.3-0.3,0.3-0.5 L95.5,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.5,31.3c-0.1-0.2-0.3-0.3-0.6-0.2s-0.3,0.4-0.2,0.6l1.4,3.1c0.1,0.2,0.3,0.3,0.6,0.2 c0.2-0.1,0.3-0.3,0.2-0.6C86.9,34.5,85.5,31.3,85.5,31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67,41.9c-0.1-0.2-0.4-0.2-0.6-0.1c-0.2,0.1-0.2,0.4-0.1,0.6l2,2.8c0.1,0.2,0.4,0.2,0.6,0.1 c0.2-0.1,0.2-0.4,0.1-0.6L67,41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.7,48.6c-0.2-0.2-0.4-0.2-0.6,0c-0.2,0.2-0.2,0.4,0,0.6l2.3,2.5c0.2,0.2,0.4,0.2,0.6,0 c0.2-0.2,0.2-0.4,0-0.6L58.7,48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M51.2,56.1c-0.2-0.2-0.4-0.1-0.6,0s-0.1,0.4,0,0.6l2.5,2.3c0.2,0.2,0.4,0.1,0.6,0s0.1-0.4,0-0.6L51.2,56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.4,64.3c-0.2-0.1-0.5-0.1-0.6,0.1c-0.1,0.2-0.1,0.4,0.1,0.6l2.8,2c0.2,0.1,0.5,0.1,0.6-0.1 c0.1-0.2,0.1-0.4-0.1-0.6L44.4,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.8,84.1l-3.1-1.4c-0.2-0.1-0.5,0-0.6,0.2c-0.1,0.2,0,0.5,0.2,0.6l3.1,1.4c0.2,0.1,0.5,0,0.6-0.2 C37.1,84.4,37,84.2,36.8,84.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.6,93.4l3.3,1.1c0.2,0.1,0.5-0.1,0.5-0.3c0.1-0.2,0-0.5-0.3-0.5l-3.2-1.1c-0.2-0.1-0.5,0.1-0.5,0.3 C29.2,93.1,29.4,93.4,29.6,93.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.9,103.8l3.4,0.7c0.2,0.1,0.5-0.1,0.5-0.3s-0.1-0.4-0.3-0.5l-3.4-0.7c-0.2-0.1-0.5,0.1-0.5,0.3 S26.6,103.7,26.9,103.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.2,114.3l3.4,0.4c0.2,0,0.4-0.1,0.5-0.4c0-0.2-0.1-0.4-0.4-0.5l-3.4-0.4c-0.2,0-0.4,0.1-0.5,0.4 C24.8,114,25,114.2,25.2,114.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.1,134.7c0-0.2-0.2-0.4-0.5-0.4l-3.4,0.4c-0.2,0-0.4,0.2-0.4,0.5c0,0.2,0.2,0.4,0.5,0.4l3.4-0.4 C29,135.2,29.1,135,29.1,134.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.7,144.9c0-0.2-0.3-0.4-0.5-0.3l-3.4,0.7c-0.2,0.1-0.4,0.3-0.3,0.5c0,0.2,0.3,0.4,0.5,0.3l3.4-0.7 C30.6,145.3,30.8,145.1,30.7,144.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.4,154.8c-0.1-0.2-0.3-0.3-0.5-0.3l-3.2,1.1c-0.2,0.1-0.3,0.3-0.3,0.5s0.3,0.3,0.5,0.3l3.2-1.1 C33.3,155.2,33.4,155,33.4,154.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.5,164.1l-3.1,1.4c-0.2,0.1-0.3,0.4-0.2,0.6c0.1,0.2,0.3,0.3,0.6,0.2l3.1-1.4c0.2-0.1,0.3-0.4,0.2-0.6 C36.9,164.1,36.7,164,36.5,164.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M46.7,182l-2.8,2c-0.2,0.1-0.2,0.4-0.1,0.6s0.4,0.2,0.6,0.1l2.8-2c0.2-0.1,0.2-0.4,0.1-0.6 S46.9,181.8,46.7,182z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M53.1,190l-2.5,2.3c-0.2,0.2-0.2,0.4,0,0.6c0.2,0.2,0.4,0.2,0.6,0l2.5-2.3c0.2-0.2,0.2-0.4,0-0.6 C53.6,189.9,53.3,189.8,53.1,190z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.4,197.3l-2.3,2.5c-0.2,0.2-0.1,0.4,0,0.6s0.4,0.1,0.6,0l2.3-2.5c0.2-0.2,0.1-0.4,0-0.6 S60.5,197.2,60.4,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.3,203.8l-2,2.8c-0.1,0.2-0.1,0.4,0.1,0.6c0.2,0.1,0.4,0.1,0.6-0.1l2-2.8c0.1-0.2,0.1-0.4-0.1-0.6 C68.7,203.6,68.5,203.6,68.3,203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86.7,214c-0.2-0.1-0.5,0-0.6,0.2l-1.4,3.1c-0.1,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0,0.6-0.2l1.4-3.1 C87,214.3,86.9,214.1,86.7,214z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.2,217.6c-0.2-0.1-0.5,0.1-0.5,0.3l-1.1,3.2c-0.1,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.5-0.1,0.5-0.3l1.1-3.2 C96.6,218,96.5,217.7,96.2,217.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M106.2,220.3c-0.2-0.1-0.4,0.1-0.5,0.3l-0.7,3.3c-0.1,0.2,0.1,0.4,0.3,0.5s0.4-0.1,0.5-0.3l0.7-3.3 C106.5,220.6,106.4,220.4,106.2,220.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M116.3,221.9c-0.2,0-0.4,0.1-0.5,0.4l-0.4,3.4c0,0.2,0.1,0.4,0.4,0.5c0.2,0,0.4-0.1,0.5-0.4l0.4-3.4 C116.7,222.2,116.5,221.9,116.3,221.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M136.8,221.9c-0.2,0-0.4,0.2-0.4,0.5l0.4,3.4c0,0.2,0.2,0.4,0.5,0.4c0.2,0,0.4-0.2,0.4-0.5l-0.4-3.4 C137.2,222.1,137,221.9,136.8,221.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M147.4,220.6c-0.1-0.2-0.3-0.4-0.5-0.3s-0.4,0.3-0.3,0.5l0.7,3.4c0.1,0.2,0.3,0.4,0.5,0.3 c0.2-0.1,0.4-0.3,0.3-0.5L147.4,220.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M157.3,217.9c-0.1-0.2-0.3-0.3-0.5-0.3c-0.2,0.1-0.3,0.3-0.3,0.5l1.1,3.2c0.1,0.2,0.3,0.3,0.5,0.3 c0.2-0.1,0.3-0.3,0.3-0.5L157.3,217.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M166.9,214.2c-0.1-0.2-0.4-0.3-0.6-0.2c-0.2,0.1-0.3,0.4-0.2,0.6l1.4,3.1c0.1,0.2,0.4,0.3,0.6,0.2 c0.2-0.1,0.3-0.4,0.2-0.6L166.9,214.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M184.7,203.8c-0.1-0.2-0.4-0.2-0.6-0.1s-0.2,0.4-0.1,0.6l2,2.8c0.1,0.2,0.4,0.2,0.6,0.1s0.2-0.4,0.1-0.6 L184.7,203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M192.6,197.3c-0.2-0.2-0.4-0.2-0.6,0c-0.2,0.2-0.2,0.4,0,0.6l2.3,2.5c0.2,0.2,0.4,0.2,0.6,0 c0.2-0.2,0.2-0.4,0-0.6L192.6,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M199.9,190c-0.2-0.2-0.4-0.1-0.6,0s-0.1,0.4,0,0.6l2.5,2.3c0.2,0.2,0.4,0.1,0.6,0s0.1-0.4,0-0.6L199.9,190z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M206.4,182c-0.2-0.1-0.4-0.1-0.6,0.1s-0.1,0.4,0.1,0.6l2.8,2c0.2,0.1,0.4,0.1,0.6-0.1s0.1-0.4-0.1-0.6 L206.4,182z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M219.7,165.5l-3.1-1.4c-0.2-0.1-0.5,0-0.6,0.2c-0.1,0.2,0,0.5,0.2,0.6l3.1,1.4c0.2,0.1,0.5,0,0.6-0.2 C220,165.9,219.9,165.6,219.7,165.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M223.5,155.6l-3.2-1.1c-0.2-0.1-0.5,0.1-0.5,0.3c-0.1,0.2,0.1,0.5,0.3,0.5l3.2,1.1c0.2,0.1,0.5-0.1,0.5-0.3 C223.8,155.9,223.7,155.6,223.5,155.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M226.2,145.3l-3.3-0.7c-0.2-0.1-0.4,0.1-0.5,0.3s0.1,0.4,0.3,0.5l3.3,0.7c0.2,0.1,0.4-0.1,0.5-0.3 S226.4,145.3,226.2,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M227.8,134.7l-3.4-0.4c-0.2,0-0.4,0.1-0.5,0.4c0,0.2,0.1,0.4,0.4,0.5l3.4,0.4c0.2,0,0.4-0.1,0.5-0.4 C228.2,135,228,134.8,227.8,134.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M223.9,114.3c0,0.2,0.2,0.4,0.5,0.4l3.4-0.3c0.2,0,0.4-0.2,0.4-0.5c0-0.2-0.2-0.4-0.5-0.4l-3.4,0.3 C224.1,113.8,223.9,114,223.9,114.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M222.3,104.1c0.1,0.2,0.3,0.4,0.5,0.3l3.3-0.7c0.2-0.1,0.4-0.3,0.3-0.5c-0.1-0.2-0.3-0.4-0.5-0.3l-3.3,0.7 C222.4,103.7,222.3,103.9,222.3,104.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M219.7,94.2c0.1,0.2,0.3,0.3,0.5,0.3l3.2-1.1c0.2-0.1,0.3-0.3,0.3-0.5c-0.1-0.2-0.3-0.3-0.5-0.3l-3.2,1.1 C219.7,93.8,219.6,94,219.7,94.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M216.6,84.9l3.1-1.4c0.2-0.1,0.3-0.3,0.2-0.6c-0.1-0.2-0.4-0.3-0.6-0.2l-3.1,1.4c-0.2,0.1-0.3,0.3-0.2,0.6 C216.1,84.9,216.4,85,216.6,84.9L216.6,84.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M208.6,64.3l-2.8,2c-0.2,0.1-0.2,0.4-0.1,0.6s0.4,0.2,0.6,0.1l2.8-2c0.2-0.1,0.2-0.4,0.1-0.6 C209.1,64.2,208.8,64.2,208.6,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M201.9,56.1l-2.5,2.3c-0.2,0.2-0.2,0.4,0,0.6c0.2,0.2,0.4,0.2,0.6,0l2.5-2.3c0.2-0.2,0.2-0.4,0-0.6 C202.3,55.9,202.1,55.9,201.9,56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M194.3,48.6l-2.3,2.5c-0.2,0.2-0.1,0.4,0,0.6s0.4,0.1,0.6,0l2.3-2.5c0.2-0.2,0.1-0.4,0-0.6 S194.5,48.4,194.3,48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M186,41.9l-2,2.8c-0.1,0.2-0.1,0.5,0.1,0.6s0.4,0.1,0.6-0.1l2-2.8c0.1-0.2,0.1-0.5-0.1-0.6 S186.1,41.7,186,41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M168.1,31.1c-0.2-0.1-0.5,0-0.6,0.2l-1.4,3.1c-0.1,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0,0.6-0.2l1.4-3.1 C168.4,31.5,168.3,31.2,168.1,31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M158.1,27.3c-0.2-0.1-0.5,0-0.5,0.3l-1.1,3.2c-0.1,0.2,0.1,0.5,0.3,0.5c0.2,0.1,0.5,0,0.5-0.3l1.1-3.2 C158.5,27.6,158.3,27.4,158.1,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M147.8,24.5c-0.2,0-0.4,0.1-0.5,0.3l-0.7,3.4c-0.1,0.2,0.1,0.5,0.3,0.5s0.4-0.1,0.5-0.3l0.7-3.4 C148.2,24.8,148,24.6,147.8,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.2,22.9c-0.2,0-0.4,0.1-0.5,0.4l-0.4,3.4c0,0.2,0.1,0.4,0.4,0.5c0.2,0,0.4-0.1,0.5-0.4l0.4-3.4 C137.6,23.1,137.5,22.9,137.2,22.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.1,127.1c-1.4-0.8-1.9-2.7-1.1-4.1c0.8-1.4,2.7-1.9,4.1-1.1s1.9,2.7,1.1,4.1 C228.4,127.4,226.5,127.9,225.1,127.1L225.1,127.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.2,77.5c-1.7,0-3-1.3-3-3c0-1.7,1.4-3,3-3c1.7,0,3,1.3,3,3S214.9,77.5,213.2,77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.1,40.4c-1.4,0.8-3.3,0.3-4.1-1.1c-0.8-1.4-0.3-3.3,1.1-4.1c1.4-0.8,3.3-0.3,4.1,1.1 S179.5,39.6,178.1,40.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.1,25.9c-0.8,1.4-2.7,1.9-4.1,1.1c-1.4-0.8-1.9-2.7-1.1-4.1c0.8-1.4,2.7-1.9,4.1-1.1 C129.4,22.7,129.9,24.5,129.1,25.9L129.1,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.5,37.8c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S79.5,36.2,79.5,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.5,73c0.8,1.4,0.3,3.3-1.1,4.1s-3.3,0.3-4.1-1.1c-0.8-1.4-0.3-3.3,1.1-4.1S41.6,71.5,42.5,73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,121.9c1.4,0.8,1.9,2.7,1.1,4.1c-0.8,1.4-2.7,1.9-4.1,1.1c-1.4-0.8-1.9-2.7-1.1-4.1 C24.7,121.6,26.5,121.1,28,121.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.8,171.5c1.7,0,3,1.3,3,3s-1.3,3-3,3c-1.7,0-3-1.3-3-3S38.2,171.5,39.8,171.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75,208.6c1.4-0.8,3.3-0.3,4.1,1.1c0.8,1.4,0.3,3.3-1.1,4.1c-1.4,0.8-3.3,0.3-4.1-1.1S73.5,209.4,75,208.6 L75,208.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.9,223.1c0.8-1.4,2.7-1.9,4.1-1.1c1.4,0.8,1.9,2.7,1.1,4.1c-0.8,1.4-2.7,1.9-4.1,1.1 C123.6,226.3,123.1,224.5,123.9,223.1L123.9,223.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.6,211.2c0-1.7,1.3-3,3-3s3,1.4,3,3c0,1.7-1.3,3-3,3S173.6,212.8,173.6,211.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.6,176c-0.8-1.4-0.3-3.3,1.1-4.1c1.4-0.8,3.3-0.3,4.1,1.1c0.8,1.4,0.3,3.3-1.1,4.1 C213.2,178,211.4,177.5,210.6,176L210.6,176z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.1,130.4c-3.3-1.9-4.4-6.1-2.5-9.3c1.9-3.3,6.1-4.4,9.3-2.5s4.4,6.1,2.5,9.3S126.4,132.3,123.1,130.4 L123.1,130.4z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.6,121.9l-37.3-21.5c-1.4-0.8-3.2-0.3-4,1.1c-0.8,1.4-0.3,3.2,1.1,4l37.3,21.5L128.6,121.9z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.6,91.9c0.7-0.4,0.9-1.3,0.5-2c-0.4-0.7-1.3-0.9-2-0.5l-60.5,35l1.5,2.5L187.6,91.9z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.3,113.8c0.3-0.2,0.8-0.1,1,0.3l0,0c0.2,0.3,0.1,0.8-0.3,1l-80.4,46.8c-0.3,0.2-0.8,0.1-1-0.3l0,0 c-0.2-0.3-0.1-0.8,0.3-1L145.3,113.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock1Hands);
export default __webpack_public_path__ + "static/media/clock-1-hands.35ff8f4108aa3444c34c67623e013f90.svg";
export { ForwardRef as ReactComponent };